var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-entry-list" },
    [
      _c("title-block", { attrs: { title: _vm.title } }),
      _c(
        "div",
        { staticClass: "box" },
        [
          !_vm.list
            ? [_c("SkeletonLoader", { attrs: { lines: 25 } })]
            : _vm._e(),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.list
              ? _c(
                  "div",
                  [_c("EntryTable", { attrs: { entries: _vm.entries } })],
                  1
                )
              : _vm._e()
          ])
        ],
        2
      ),
      _vm.chunkedEntries.length > 1
        ? _c(
            "div",
            { staticClass: "pagination is-centered" },
            [
              _c("paginate", {
                attrs: {
                  "page-count": _vm.chunkedEntries.length,
                  "page-range": 5,
                  "margin-pages": 2,
                  "container-class": "pagination-list",
                  "page-link-class": "pagination-link",
                  "active-class": "is-current",
                  "no-li-surround": true,
                  "prev-link-class": "pagination-link is-prev material-icons",
                  "prev-text": "arrow_back_ios",
                  "next-text": "arrow_forward_ios",
                  "next-link-class": "pagination-link is-next material-icons",
                  "break-view-link-class": "is-break-view",
                  "disabled-class": "is-disabled",
                  "click-handler": _vm.changePage
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }